import React from 'react';
import ListItemContent from './ListItemContent';
import { getClassNames } from '../../helpers/classHelpers';
import { LinkProps } from 'react-router-dom';
import { Icons } from '../icon/icons/material';
import { SvgIcons } from '../icon/icons/svg';
import style from './List.module.scss';

export type ListProps = {
    listItems: ListItemContentProps[];
    isDisabled?: boolean;
    className?: string;
    useGradient?: boolean;
};

export type ListItemContentProps = {
    title: string;
    url?: string;
    linkProps?: Omit<LinkProps, 'to'>;
    id: string;
    leadingContent?: React.ReactNode;
    onClick?: () => void;
    onHoverIconClick?: () => void;
    isActive?: boolean;
    hoverIcon?: React.ReactElement;
    hoverIconClassName?: string;
    icon?: Icons | SvgIcons | string;
    className?: string;
    useGradient?: boolean;
};

const List: React.FC<ListProps> = ({ isDisabled, listItems, className, useGradient }) => {
    return (
        <ul className={getClassNames([className, style.list, isDisabled && style._disabled])}>
            {listItems.map((item) => <ListItemContent key={item.id} item={item} useGradient={useGradient} />)}
        </ul>
    );
};

export default List;
